module.exports = __webpack_public_path__ + "static/img/no-img-available.9ae40db.png";